'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.I18nManager = undefined;

var _arrayTo = require('d2-utilizr/lib/arrayTo');

var _arrayTo2 = _interopRequireDefault(_arrayTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var I18nManager = exports.I18nManager = undefined;

exports.I18nManager = I18nManager = function I18nManager(refs, config) {
    var t = this;

    var translations = config || {};

    // prototype
    t.add = function (obj, force) {
        if (force) {
            translations = obj;
        } else {
            $.extend(translations, obj);
        }
    };

    t.get = function (key) {
        return key ? translations[key] : translations;
    };
};

I18nManager.prototype.applyTo = function (modules) {
    var t = this;

    (0, _arrayTo2.default)(modules).forEach(function (module) {
        module.i18nManager = t;
    });
};
//# sourceMappingURL=I18nManager.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/manager/I18nManager.js
 ** module id = 143
 ** module chunks = 0 1
 **/